import { AllHtmlEntities } from "html-entities";

import {
  NOTIFICATION_MESSAGE_MAX_LENGTH,
  PREMIUM_RECIPIENTS_TYPE,
  STOCK_NOTIFICATION_TYPE
} from "./constants";

function extractContent(html) {
  const withoutTags = html.replace(/<[^>]+>/g, "");
  const decoded = AllHtmlEntities.decode(withoutTags);
  return decoded.replace(/\s+/g, " ").trim();
}

function getMessageShortcut(message) {
  if (message?.config?.title) {
    return message.config.title;
  }

  return message.message;
}

export default function setupNotificationMessage(
  message,
  markets,
  tickers,
  userData,
  { messageMaxLength = NOTIFICATION_MESSAGE_MAX_LENGTH } = {}
) {
  if (message.config === null) {
    message.config = {
      market: markets[message.item_id],
      ticker: tickers[message.item_id],
      recipients: {
        type: PREMIUM_RECIPIENTS_TYPE
      },
      title: null,
      content_type: STOCK_NOTIFICATION_TYPE,
      check_user_stock: true
    };
  }

  message.shortcut =
    message.content_type === STOCK_NOTIFICATION_TYPE
      ? message.config.ticker
      : getMessageShortcut(message);

  if (
    message.content_type !== STOCK_NOTIFICATION_TYPE &&
    message.config.html_message
  ) {
    const htmlContent =
      message?.config?.title ?? extractContent(message.config.html_message);

    if (htmlContent.length > messageMaxLength) {
      message.message = htmlContent.substring(0, messageMaxLength) + "...";
    } else {
      message.message = htmlContent;
    }
  }

  const messageIsPremium =
    message.config.recipients.type === PREMIUM_RECIPIENTS_TYPE;

  if (messageIsPremium && (!userData || !userData.has_access)) {
    message.blurred = true;
  }

  return message;
}
